/* containers.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./containers.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@compiled/react';
import { getStyleProps } from '../utils';

// ==============================
// Root Container
// ==============================

export var containerCSS = function containerCSS() {
  return {};
};
var containerStyles = {
  default: "_11c81ixg _kqswh2mm _lcxv1rj4 _1tn22smr",
  rtl: "_1eim1xrj",
  disabled: "_80om13gf"
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var SelectContainer = function SelectContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isDisabled = props.isDisabled,
    isRtl = props.isRtl,
    xcss = props.xcss;
  var _getStyleProps = getStyleProps(props, 'container', {
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }),
    className = _getStyleProps.className,
    css = _getStyleProps.css;
  return /*#__PURE__*/React.createElement("div", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    className: ax([containerStyles.default, isRtl && containerStyles.rtl, isDisabled && containerStyles.disabled, cx(className, xcss, '-container')])
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ,
    style: css
  }, innerProps), children);
};

// ==============================
// Value Container
// ==============================

export var valueContainerCSS = function valueContainerCSS() {
  return {};
};
var valueContainerStyles = {
  default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
  flex: "_1e0c1txw",
  compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var ValueContainer = function ValueContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    isMulti = props.isMulti,
    hasValue = props.hasValue,
    isCompact = props.isCompact,
    xcss = props.xcss,
    controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
  var _getStyleProps2 = getStyleProps(props, 'valueContainer', {
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }),
    css = _getStyleProps2.css,
    className = _getStyleProps2.className;
  return /*#__PURE__*/React.createElement("div", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    className: ax([valueContainerStyles.default, isMulti && hasValue && controlShouldRenderValue && valueContainerStyles.flex, isCompact && valueContainerStyles.compact, cx(className, xcss, '-ValueContainer')])
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ,
    style: css
  }, innerProps), children);
};

// ==============================
// Indicator Container
// ==============================

export var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {};
};
var indicatorContainerStyles = null;

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
    innerProps = props.innerProps,
    xcss = props.xcss;
  var _getStyleProps3 = getStyleProps(props, 'indicatorsContainer', {
      indicators: true
    }),
    css = _getStyleProps3.css,
    className = _getStyleProps3.className;
  return /*#__PURE__*/React.createElement("div", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    style: css
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    ,
    className: ax(["_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66", cx(className, xcss, '-IndicatorsContainer')])
  }, innerProps), children);
};